import { render, staticRenderFns } from "./PunchManage.vue?vue&type=template&id=53675970&"
import script from "./PunchManage.vue?vue&type=script&lang=js&"
export * from "./PunchManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VChip,VContainer,VDivider})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53675970')) {
      api.createRecord('53675970', component.options)
    } else {
      api.reload('53675970', component.options)
    }
    module.hot.accept("./PunchManage.vue?vue&type=template&id=53675970&", function () {
      api.rerender('53675970', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Punch/PunchManage/PunchManage.vue"
export default component.exports